import React from 'react';
import styled from '@emotion/styled';
const defaultSize = 15;
const defaultColor = '#000';

const Image = styled.div<{ icon: any; width: number; height: number; color: string }>`
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => `${height}px`};
  mask-image: url(${({ icon }) => icon});
  mask-size: contain;
  mask-repeat: no-repeat;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  background-color: ${({ color }) => `${color}`};
`;

type Props = {
  icon: any;
  size?: number;
  width?: number;
  height?: number;
  color?: string;
  onClick?: () => void;
};

const Icon = ({ icon, size, width, height, color, onClick }: Props) => {
  const styles = { width: defaultSize, height: defaultSize, color: defaultColor };
  if (size) {
    styles.width = size;
    styles.height = size;
  }
  if (width && height) {
    styles.width = width;
    styles.height = height;
  }

  if (color) {
    styles.color = color;
  }

  return (
    <Image
      onClick={onClick}
      icon={icon}
      width={styles.width}
      height={styles.height}
      color={styles.color}
    />
  );
};

export default Icon;
